import * as React from "react";
import TabName from "./interfaces/tabName";
import { handleHideSideBarSubLevel } from "../../modules/sidebar";
const TabHeader: React.SFC<any> = ({
  visibleTabName,
  onClickAll,
  onClickEdit,
  onClickByCategory,
}) => {
  return (
    <div className="coverages__tabs-container">
          {/*<button
        className={`coverages__tab ${
          visibleTabName === TabName.ALL ? "coverages__tab--active" : ""
        }`}
        onClick={onClickAll}
      >
        <div className="coverages__tab-title">Dokument</div>
        <div
          className={`coverages__tab-marker ${
            visibleTabName === TabName.ALL
              ? "coverages__tab-marker--active"
              : ""
          }`}
        ></div>
      </button>
      <button
        className={`coverages__tab ${
          visibleTabName === TabName.EDIT ? "coverages__tab--active" : ""
        }`}
        onClick={onClickEdit}
      >
          <div className="coverages__tab-title">Kategori</div>
          <div
          className={`coverages__tab-marker ${
            visibleTabName === TabName.EDIT
              ? "coverages__tab-marker--active"
              : ""
          }`}
        ></div>
      </button>
      <button
        className={`coverages__tab  ${
          visibleTabName === TabName.BY_CATEGORY ? "coverages__tab--active" : ""
        }`}
        onClick={onClickByCategory}
      >
        <div className="coverages__tab-title">Anteckning</div>
        <div
          className={`coverages__tab-marker ${
            visibleTabName === TabName.BY_CATEGORY
              ? "coverages__tab-marker--active"
              : ""
          }`}
        ></div>
          </button>*/}
    </div>
  );
};

export default TabHeader;
